import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import ReactTooltip from "react-tooltip";
import * as Yup from "yup";

import arrowdown from "../../../Assets/arrowdown.svg";
import styles from "./MyProfile.module.scss";
import "./styles.scss";
import info from "../../../Assets/info.svg";

import Sidebar from "../../../components/consolecomponents/sidebar/Sidebar";
import { useAllProjects } from "../../../hooks/DevProjectHooks";
import IsLoading from "../../../util/loader/IsLoading";
import FormikControl from "../../../util/formcomponents/FormikControl";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";
import ChangePassModal from "../../../components/consolecomponents/modal/ChangePassModal";
import ConsoleLocalStorage from "../../../storage/storage";
import { useGetDev, useUpdateDev } from "../../../hooks/DevAuthHooks";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("Required").matches(/^(([A-Za-z]{1,2})?|[.' ]){3}?([A-Za-z]{3,})+$/i,"Invalid Name"),
  lastName: Yup.string().required("Required").matches(/^(([A-Za-z]{1,2})?|[.' ]){3}?([A-Za-z]{3,})+$/i,"Invalid Name"),
  // email: Yup.string().required(),
  phoneNumber: Yup.string().min(10,"Minimum 10 digits required")
    .required("Required")
    .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, "Invalid phone Number"),
  // country: Yup.string().required("Required"),
});

const countryOptions = [
  { key: "India", value: "IN" },
  { key: "USA", value: "USA" },
];

const MyProfile = () => {
  const [showSideBarList, setShowSidebarList] = useState(false);
  const history = useHistory();
  const [showChangePass, setShowChangePass] = useState(false);

  /**
   * Get Curr Developer
   */
  const {
    data: user,
    isLoading: userLoading,
    isError: userError,
  } = useGetDev(ConsoleLocalStorage.getUser().id);

  /**
   * Get All projects for sidebar dropdown
   */
  const {
    data: projects,
    isLoading: projectsLoading,
    isError: projectsError,
  } = useAllProjects();

  /**
   * Update Developer
   */
  const { mutate } = useUpdateDev(ConsoleLocalStorage.getUser().id);

  const onSubmit = (values) => {
    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      // country: values.country,
    };
    mutate(data);
  };

  if (projectsLoading || userLoading) {
    return <IsLoading />;
  }

  return (
    <>
      <ChangePassModal
        showChangePass={showChangePass}
        setShowChangePass={setShowChangePass}
      />
      <div className={styles.profile}>
        <Sidebar>
          <section className="">
            <div
              onClick={() => setShowSidebarList(!showSideBarList)}
              className="sidebar_projects"
            >
              <h3 className="">
                {`All Projects (${projects?.length})`}
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </h3>
              {showSideBarList ? (
                <ul className="sidebar_projectlist">
                  {projects.map((project) => (
                    <li key={project.id}>
                      <Link to={`/console/${project.id}`}>
                        <span className="sidebar_list_items">
                          {project.name}
                        </span>{" "}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
        </Sidebar>
        <div className={`${styles.main} my-profile`}>
          <h2 className={styles.heading}>My Profile</h2>
          <div className={styles.body}>
            <Formik
              initialValues={ user
                // user.phoneNumber ? user : { ...user, phoneNumber: "" }
              }
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize
              validateOnChange
            >
              {(formik) => {
                // console.log(formik);
                return (
                  <Form>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "48% 48%",
                        gap: "1em",
                        width: "100%",
                      }}
                    >
                      <span>
                        <FormikControl
                          control="input"
                          type="text"
                          maxLen="60"
                          required={false}
                          label="First Name"
                          name="firstName"
                          onChange={(e)=>{
                            formik.setFieldTouched('firstName')
                            formik.handleChange(e);
                          }}
                        />
                      </span>
                      <span>
                        <FormikControl
                          control="input"
                          type="text"
                          maxLen="60"
                          required={false}
                          label="Last Name"
                          name="lastName"
                          onChange={(e)=>{
                            formik.setFieldTouched('lastName')
                            formik.handleChange(e);
                          }}
                        />
                      </span>
                    </div>

                    <div className="">
                      <label
                        style={{ display: "inline" }}
                        htmlFor={"email"}
                        className="xs-lable-select white "
                      >
                        Email ID
                      </label>
                      <p className={styles.ibutton}>
                        <img
                          data-class="myTooltipClass"
                          data-tip="To change your Email ID contact admin"
                          src={info}
                          alt=""
                        />
                      </p>
                      <ReactTooltip
                        arrowColor="transparent"
                        backgroundColor="#707070"
                        place="right"
                        type="dark"
                        effect="solid"
                      />
                    </div>
                    <div className="primary_input">
                      <Field>
                        {({ field }) => {
                          // console.log(field);
                          return (
                            <input
                              id={"email"}
                              name="email"
                              value={field.value.email}
                              style={{ color: "#646464" }}
                              disabled
                            />
                          );
                        }}
                      </Field>
                    </div>

                    
                    <FormikControl
                      control="input"
                      type="number"
                      required={false}
                      label="Contact Number"
                      name="phoneNumber"
                      onChange={e => {
                        formik.setFieldTouched('phoneNumber');
                        formik.handleChange(e);
                    }} 
                    />

                    <div>
                      <label
                        style={{ display: "inline" }}
                        htmlFor={"country"}
                        className="xs-lable-select white "
                      >
                        Country
                      </label>
                      <p className={styles.ibutton}>
                        <img
                          data-class="myTooltipClass"
                          data-tip="Please reach out to Admin, If you would like to change your Country Name."
                          src={info}
                          alt=""
                        />
                      </p>
                      <ReactTooltip
                        arrowColor="transparent"
                        backgroundColor="#707070"
                        place="right"
                        type="dark"
                        effect="solid"
                      />
                    </div>
                    <div className="primary_input">
                      <Field>
                        {({ field }) => {
                          return (
                            <input
                              id={"country"}
                              name="country"
                              value={field.value.country}
                              style={{ color: "#646464" }}
                              disabled
                            />
                          );
                        }}
                      </Field>
                    </div>
                   
                    <div>
                      <label
                        style={{ display: "inline" }}
                        htmlFor={"state"}
                        className="xs-lable-select white "
                      >
                        State
                      </label>
                      <p className={styles.ibutton}>
                        <img
                          data-class="myTooltipClass"
                          data-tip="Please reach out to Admin, If you would like to change your State Name."
                          src={info}
                          alt=""
                        />
                      </p>
                      <ReactTooltip
                        arrowColor="transparent"
                        backgroundColor="#707070"
                        place="right"
                        type="dark"
                        effect="solid"
                      />
                    </div>
                    <div className="primary_input">
                      <Field>
                        {({ field }) => {
                          return (
                            <input
                              id={"state"}
                              name="state"
                              value={field.value.state}
                              style={{ color: "#646464" }}
                              disabled
                            />
                          );
                        }}
                      </Field>
                    </div>

                    <div>
                      <label
                        style={{ display: "inline" }}
                        htmlFor={"email"}
                        className="xs-lable-select white "
                      >
                        City
                      </label>
                      <p className={styles.ibutton} >
                        <img
                          data-class="myTooltipClass"
                          data-tip="Please reach out to Admin, If you would like to change your City Name."
                          src={info}
                          alt=""
                        />
                      </p>
                      <ReactTooltip
                        arrowColor="transparent"
                        backgroundColor="#707070"
                        place="right"
                        type="dark"
                        effect="solid"
                      />
                    </div>
                    <div className="primary_input">
                      <Field>
                        {({ field }) => {
                          return (
                            <input
                              id={"city"}
                              name="city"
                              value={field.value.city}
                              style={{ color: "#646464" }}
                              disabled
                            />
                          );
                        }}
                      </Field>
                    </div>
                    
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      className=""
                    >
                      <SecondaryButton
                        as="div"
                        onClick={() => setShowChangePass(true)}
                      >
                        Change Password
                      </SecondaryButton>
                      <PrimaryButton>Save</PrimaryButton>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyProfile;
